import styles from "../../styles/Switch.module.less";

type SwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
};

const Switch = (props: SwitchProps) => {
  const { value, onChange, disabled, label = "Toggle" } = props;

  return (
    <label className={styles.switch}>
      <input
        className={styles.input}
        type="checkbox"
        onChange={(e) => onChange(e.currentTarget.checked)}
        checked={value}
        disabled={disabled}
      />
      <span className={`${styles.slider} ${disabled ? styles.disabled : ""}`} />
      <span className={styles.visuallyHidden}>{label}</span>
    </label>
  );
};
export default Switch;
